<script>
import moment from "moment";
import {getInvoiceArray, getInvoiceTypes, removeInvoice, uploadAttachment} from "@/api/system/common";

export default {
  name: "InvoiceAttachment",
  props: {
    rows: {
      type: Object,
    }
  },
  mounted() {
    // 读取数据
    this.$Spin.show()
    getInvoiceTypes().then(res => {
      this.invoiceTypes = res.data.payload
      // 加载记录
      getInvoiceArray(this.rows.id).then(rx => {
        this.$Spin.hide()
        this.documentArray = rx.data.payload
      }).then(e => this.$Message.error(e.message))
    }).catch(e => {
      this.$Spin.hide()
      this.$Message.error(e.message)
    })
  },
  methods: {
    uploadDOM() {
      if (this.types.length === 0) {
        this.$Message.error('请先选择文件类型')
        return;
      }
      this.$refs['inputDOM'].click()
    },
    appendArray(event) {
      this.documentArray.splice(0, 0, {
        fakeId: new Date().getTime(),
        typeName: this.invoiceTypes.filter(v => v.value === this.types)[0]['label'],
        types: this.types,
        createTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        creator: this.$store.state.user.userName,
        fileName: event.target.files[0].name,
        fileTarget: event.target.files[0],
        id: this.rows.id,
        fileUri: '等待上传'
      })
    },
    uploadDocument(row) {
      this.$Spin.show()
      let formData = new FormData();
      for (let item in row) {
        formData.append(item, row[item])
      }
      uploadAttachment(formData).then(res => {
        this.$Spin.hide()
        if (res.data.status) {
          this.$Message.success(res.data.msg)
          this.documentArray = res.data.payload
          this.$refs['inputDOM'].value = null
        } else {
          this.$Message.error(res.data.message)
        }
      }).catch(e => {
        this.$Spin.hide()
        this.$Message.error(e.message)
      })
    }
  },
  data() {
    return {
      types: '',
      invoiceTypes: [],
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '票据类型',
          key: 'typeName',
          width: 100,
          align: 'center',
        },
        {
          title: '创建人',
          key: 'creator',
          width: 120,
          align: 'center',
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 180,
          align: 'center',
        },
        {
          title: '文件名称',
          key: 'fileName',
          align: 'center',
        },
        {
          title: '文件地址',
          key: 'fileUri',
          width: 120,
          align: 'center',
          render(h, {row}) {
            if (row.fileUri.substring(0, 4) === 'http') {
              return h('Button', {props: {type: 'success', size: 'small'}, on: {click: () => {
                window.open(row.fileUri, '_blank');
                  }}}, '点击下载')
            } else {
              return h('Tag', {}, '等待')
            }
          }
        },
        {
          title: '操作',
          align: 'right',
          key: 'id',
          width: 140,
          render: (h, {row}) => {
            let buttonArray = []
            if (row.fileUri.substring(0, 4) === 'http') {
              buttonArray.push(h('Button', {props: {type: 'error', size: 'small'}, on: {click: () => {
                    this.$Modal.confirm({
                      title: '是否删除票据 ' + row.fileName,
                      content: '是否删除该票据，删除后无法找回，请确认！！！',
                      onOk: () => {
                        this.$Spin.show()
                        removeInvoice({domId: row.domId, id: row.id}).then(res => {
                          this.$Spin.hide()
                          this.documentArray = res.data.payload
                          this.$Message.success(res.data.msg)
                        }).catch(e => {
                          this.$Spin.hide()
                          this.$Message.error(e.message)
                        })
                      },
                    });
                  }}}, '删除票据'))
            } else {
              buttonArray.push(h('Button', {props: {type: 'primary', size: 'small'}, on: {click: () => {
                this.uploadDocument(row)
                  }}}, '上传'))
              buttonArray.push(h('Button', {props: {type: 'warning', size: 'small'}, style: {marginLeft: '5px'}, on: {click: () => {
                    this.documentArray = this.documentArray.filter(v => v.fakeId !== row.fakeId)
                  }}}, '取消'))
            }

            return h('div', {}, buttonArray)
          },

        }
      ],
      documentArray: [],
    }
  }
}
</script>

<template>
  <div>
    <Form ref="formInline" inline :label-width="90">
      <FormItem label="附件类型">
        <Select v-model="types" style="width:200px">
          <Option v-for="item in invoiceTypes" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>

      <Button type="primary" @click="uploadDOM">选择文件上传</Button>
    </Form>
    <Table border :columns="columns" :data="documentArray" height="250"></Table>
    <input type="file" ref="inputDOM" @change="appendArray" style="width: 1px; height: 1px; opacity: 0;">
  </div>
</template>

<style scoped>
/* 调整表头高度 */
.ivu-table-header {
  height: 30px; /* 修改为你需要的高度 */
}

</style>
